import style from "./style.scss";

import Editorial from "../../../../components/editorial";

const PopupContent = ({ titleId }) => {
  return (
    <div id={titleId} class={style.popupWrapper}>
      <Editorial>
        <h2>Solar Input Specifications</h2>
        <p>
          Most power stations list their solar input specifications in a few
          common places: a sticker on the unit, the user manual, or the
          manufacturer’s website. If your unit has multiple ports, ensure you
          use the specs for the specific port you plan to use.
        </p>

        <p>
          <strong>What you're looking for:</strong>
        </p>
        <ul>
          <li>
            <strong>Key Phrases:</strong> <mark>PV Input</mark>, <mark>PV</mark>
            , <mark>Solar Input</mark>, <mark>MPPT</mark>, or{" "}
            <mark>DC Input</mark>
          </li>
          <li>
            <strong>Example Values:</strong> <mark>12–28V⎓8A, 200W Max.</mark>{" "}
            or <mark>200W Max., VOC 12–28VDC, 8A</mark>
          </li>
        </ul>

        <p>
          <strong>Note:</strong> You may see similar values for DC Output
          (powering accessories) or AC Input (wall outlet charging). These are
          not the values you need.
        </p>

        <p>
          <strong>What these values mean:</strong>
        </p>
        <ul>
          <li>
            <mark>12–28V</mark>: This is the voltage range. 12V is the minimum,
            28V is the maximum.
          </li>
          <li>
            <mark>8A</mark>: This is the maximum current in amps.
          </li>
          <li>
            <mark>200W Max</mark>: This is the maximum input power in watts.
          </li>
          <li>
            <mark>VDC / VOC / ⎓</mark>: These are technical terms for direct
            current. You only need the numbers associated with them.
          </li>
          <li>
            <mark>PV</mark>: Stands for photovoltaic which is another word for
            solar power.
          </li>
        </ul>

        <h4>Where to find it</h4>
        <h5>On the Product</h5>
        <p>
          Look for a specification sticker on the bottom or back of the unit. On
          some models, the specs are printed directly on a protective flap
          covering the input port.
        </p>

        <h5>In the User Manual</h5>
        <p>
          Locate the "Specifications" or "Technical Parameters" table, usually
          found at the beginning or end of the manual.
        </p>

        <h5>On the Website</h5>
        <p>
          Search for your model on a search engine or the manufacturer’s site
          and look for the "Tech Specs" or "Specifications" section.
        </p>
      </Editorial>
    </div>
  );
};

export default PopupContent;
